import {
  OPEN_OVERVIEW_MODAL,
  CLOSE_OVERVIEW_MODAL,
  SET_ACTIVE_EDITOR,
  CLOSE_EDITOR,
  OPEN_NESTED_OVERVIEW_MODAL,
  CLOSE_NESTED_OVERVIEW_MODAL,
} from './types';

export const openOverviewModal = ({ component, props }) => {
  return {
    type: OPEN_OVERVIEW_MODAL,
    component,
    props,
  };
};

export const openNestedOverviewModal = ({ component }) => {
  return {
    type: OPEN_NESTED_OVERVIEW_MODAL,
    component,
  };
};

export const setActiveEditor = ({ component }) => {
  return {
    type: SET_ACTIVE_EDITOR,
    component,
  };
};

export const closeOverviewModal = () => {
  return {
    type: CLOSE_OVERVIEW_MODAL,
  };
};
export const closeNestedOverviewModal = () => {
  return {
    type: CLOSE_NESTED_OVERVIEW_MODAL,
  };
};
export const closeEditor = () => {
  return {
    type: CLOSE_EDITOR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/trekOverviewActions.js